export default __webpack_public_path__ + "static/media/F8D3CE08-22C6-486C-9C0D-2DE7C8E3A8EB_1_105_c.c234993a.jpeg";